import { render } from "./AddTitleFile.vue?vue&type=template&id=7e88b2fc&scoped=true"
import script from "./AddTitleFile.vue?vue&type=script&lang=js"
export * from "./AddTitleFile.vue?vue&type=script&lang=js"

import "./AddTitleFile.vue?vue&type=style&index=0&id=7e88b2fc&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e88b2fc"]])

export default __exports__